export const EBOOKS_PACK_PRICE = 219.00;
export const EBOOK_TOTAL_EBOOKS = 59-1;

export const EBOOK_TOTAL_PAGES = 6800;
export const EBOOK_TOTAL_RECOMMENDATION = '+500';
export const EBOOK_TOTAL_VALUE = 5031;

export const EBOOK_SAVING = `${ Math.round( ( ( EBOOK_TOTAL_VALUE - EBOOKS_PACK_PRICE ) / EBOOK_TOTAL_VALUE ) * 100 ) }%`;

